var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mx-2",attrs:{"id":"title"},on:{"click":function($event){$event.stopPropagation();return _vm.goHome.apply(null, arguments)}}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }